(function () {
    'use strict';

    angular.module('swif.openbase')

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/reservations/ckecup', {
            templateUrl: 'partials/openbase/checkup.html',
            controller: 'OpenresaCheckup',
            reloadOnSearch: false
        });
    }])

    .controller('OpenresaCheckup', [
        '$scope', 'swifFrameworkService',
        function ($scope, swif) {
            //UN SERVICE N AYANT PAS MATERIEL
            $scope.debug = {};
            $scope.link_map = {
                'partner': '/configuration/partners',
                'partner_address': '/configuration/partners',
                'department': '/configuration/departments',
                'site': '/configuration/sites',
                'team': '/configuration/teams',
                'equipment': '/configuration/equipments',
                'consumable': '/configuration/consumables',
                'consumable_category': '/configuration/consumable_categories',
                'partner_type': '/configuration/partner_types'
            };
            $scope.checkup = [
                {
                    title: 'Sites avec qtt = 0',
                    params: {domain: [['qty_available', '=', 0]]},
                    content_type: 'site',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Eqpt avec qtt = 0',
                    params: {domain: [['qty_available', '=', 0]]},
                    content_type: 'equipment',
                    edit: $scope.link_map.partner
                }
            ];
            var setError = function (check) {
                if (check.category === 'warning') {
                    check.warning = true;
                } else {
                    check.error = true;
                }
            };
            _.forEach($scope.checkup, function (check) {
                swif.data.get(check.content_type, undefined, check.params)
                .then(function (results) {
                    check.results = results;
                    if (results.length === 0) {
                        if (check.error_on_empty) {
                            setError(check);
                        } else {
                            check.success = true;
                        }
                    } else {
                        if (check.error_on_empty) {
                            check.success = true;
                        } else {
                            setError(check);
                        }
                    }
                });
            });
            $scope.toggleShowMore = function (check) {
                if (check.more) {
                    check.more = false;
                } else {
                    check.more = true;
                }
            };
            $scope.showDebug = function (item) {
                if ($scope.debug[item.id]) {
                    $scope.debug[item.id] = false;
                } else {
                    $scope.debug[item.id] = true;
                }
            };
            $scope.fix = function (check, item) {
                if (check.fix && item) {
                    var data = check.fix(item);
                    swif.data.save(check.content_type, item.id, data);
                }
            };
        }
    ]);

})();
